
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
    Card,
    CardHeader,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    Table,
    UncontrolledDropdown,
} from "reactstrap";
import ContactService from "../../../services/contactService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ProjectCompanyService from "../../../services/projectCompanyService";

class ReportList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list :[],
            alert: null
        };
        this.delete = this.delete.bind(this);
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
        ProjectCompanyService.list().then((response) => {
            console.log(response);
            this.setState({list: response});
        });
    }

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    };

    confirmDeleteAlert = (uniqueId) => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{display: "block"}}
                    title="Are you sure?"
                    onConfirm={() => this.delete(uniqueId)}
                    onCancel={this.hideDeleteAlert}
                    showCancel
                    confirmBtnBsStyle="danger"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnBsStyle="secondary"
                    cancelBtnText="Cancel"
                    btnSize=""
                >
                    You won't be able to revert this!
                </ReactBSAlert>
            )
        });
    };

    delete(uniqueId) {
        this.setState({alert: null})
        ContactService.delete(uniqueId).then((response) => {
            console.log(response);
            this.notify(
                response.responseStatus.toLowerCase(),
                response.responseStatus,
                response.message
            );
            //TODO: TO be fixed with redux implementation
            //   this.props.history.push("/admin/dashboard");
            ContactService.list().then((response) => {
                console.log(response);
                this.setState({list: response});
            });
        });
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    render() {
        let obj = this;
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <SimpleHeader
                    name="List"
                    parentName="Project Events"
                    heading="XareGrwoth"
                    newBtnUrl="/crm/meetingReport/create"
                    newBtnText="Create Meeting Report"
                />
                {this.state.alert}
                <Container className="mt--6" fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0">Project Events</h3>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                    <tr>
                                        <th className="sort" data-sort="name" scope="col">
                                            #
                                        </th>
                                        <th className="sort" data-sort="budget" scope="col">
                                            Date Created
                                        </th>
                                        <th className="sort" data-sort="budget" scope="col">
                                            Company Name
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Potential
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Interest
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Priority
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Date of Last Contact
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Date of Next Contact
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Key Contact
                                        </th>
                                        <th scope="col"/>
                                    </tr>
                                    </thead>
                                    <tbody className="list">
                                    {this.state.list.map(function (value, index) {
                                        return (
                                            <tr key={index}>
                                                <td className="budget">{index + 1}</td>
                                                <td className="budget">{value?.dateCreated}</td>
                                                <td className="budget">{value?.mainContact?.company?.legalName}</td>
                                                <td className="budget">{value?.potential}</td>
                                                <td className="budget">{value?.interest}</td>
                                                <td className="budget">{value?.priority}</td>
                                                <td className="budget">{value?.lastContact}</td>
                                                <td className="budget">{value?.nextContact}</td>
                                                <td className="budget">{value?.mainContact?.fullName}</td>
                                                <td className="text-right">
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle
                                                            color=""
                                                            size="sm"
                                                            className="btn-icon-only text-light"
                                                        >
                                                            <i className="fas fa-ellipsis-v"/>
                                                        </DropdownToggle>
                                                        <DropdownMenu
                                                            className="dropdown-menu-arrow"
                                                            right container="body"
                                                        >
                                                            <DropdownItem
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.props.history.push(
                                                                        `/admin/meetingReport/company/${value.companyUID}`
                                                                    );
                                                                }}
                                                            >
                                                                See All Reports
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.props.history.push(
                                                                        `/admin/nextSteps/list/`
                                                                    );
                                                                }}
                                                            >
                                                                See all Tasks
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default ReportList;
